/* eslint-disable camelcase */
import { ActivityEvent, ActivityEventType } from "PFTypes";

import { HistoryEntryActivityConnections } from "./parts/history_entry_activity_connections";
import { HistoryEntryGeneric } from "./parts/history_entry_generic";
import { HistoryEntryOwner } from "./parts/history_entry_owner";

export type HistoryEntryProps = {
  entry: ActivityEvent;
};

type HistoryEntryComponent = React.ComponentType<HistoryEntryProps>;

const HistoryEntryComponents: Partial<Record<ActivityEventType, HistoryEntryComponent>> & {
  default: HistoryEntryComponent;
} = {
  owner_updated: HistoryEntryOwner,
  owner_created: HistoryEntryOwner,
  owner_deleted: HistoryEntryOwner,
  activity_connections_updated: HistoryEntryActivityConnections,
  default: HistoryEntryGeneric
};

const getHistoryEntryComponent = (entry: ActivityEvent) =>
  HistoryEntryComponents[entry.event] || HistoryEntryComponents.default;

export const HistoryEntry = ({ entry }: HistoryEntryProps) => {
  const Component = getHistoryEntryComponent(entry);

  // eslint-disable-next-line react-hooks/static-components
  return <Component entry={entry} />;
};
